import {
    SET_CURRENT_USER, SET_APP_MENU, SET_BASE_URL, SET_MYKOMATSU_BASE_URL, SET_CART_COUNT, SET_MYKOMATSU_REGION, SET_KOMATSU_CARE_BROCHURES, SET_MAP_CENTER, SET_APP_LINK,
    SET_IS_MINEXPO_ENABLED
} from './types';

const reducers = (state: any = {}, action: any) => {
    switch (action.type) {
        case SET_CURRENT_USER: {
            let currentuser = state?.currentuser ?? {};
            currentuser = { ...currentuser, ...action.currentuser };
            return {
                ...state, currentuser
            };
        }
        case SET_BASE_URL: {
            const imgbaseUrl = action.imgbaseUrl;
            return {
                ...state, imgbaseUrl,
            };
        }
        case SET_APP_MENU: {
            let appmenus = state?.appmenus ?? {};
            appmenus = { ...appmenus, ...action.appmenus };
            return {
                ...state, appmenus
            };
        }

        case SET_APP_LINK : {
            let applinks = state?.applinks ?? {};
            applinks = { ...applinks, ...action.applinks };
            return {
                ...state, applinks
            };
        }

        case SET_MYKOMATSU_BASE_URL: {
            const myKomatsuBaseUrl = action.myKomatsuBaseUrl;
            return {
                ...state, myKomatsuBaseUrl,
            };
        }

        case SET_CART_COUNT: {
            let cartCount = action.cartCount;
            return {
                ...state, cartCount
            };
        }

        case SET_MYKOMATSU_REGION: {
            const myKomatsuRegion = action.myKomatsuRegion;
            return {
                ...state, myKomatsuRegion,
            };
        }

        case SET_IS_MINEXPO_ENABLED: {
            const isMinExpoEnabled = action.isMinExpoEnabled;
            return {
                ...state, isMinExpoEnabled,
            };
        }

        case SET_KOMATSU_CARE_BROCHURES: {
            const komatsuCareBrochures = action.komatsuCareBrochures;
            return {
                ...state, komatsuCareBrochures,
            };
        }
        case SET_MAP_CENTER: {
            const mapCenter = action.mapCenter;
            return {
                ...state, mapCenter,
            };
        }

        default:
            return state;
    }
};

export default reducers;




